import * as XLSX from 'xlsx';
import { models, VisualDescriptor } from 'powerbi-client';
import { VISUAL_IDS } from '../../../../constants/slicers';

class ExcelModel {
  ReportName: string;
  User: string;
  Date_Time_UTC: string;
  CompanyName: string;
  MarketsQty: string;
  UnitsQty: string;
  MarketsUnitsList: string;
  PaintDiscount: string;
  CleanDiscount: string;
  CarpetCleanDiscount: string;
  MaintenanceDiscount: string;
  OverallDiscount: string;
  PlatformFeeStatus: string;
  PlatformFee: string;
  ContractedUnits: string;
  PlatformFeePerUnit: string;
  PlatformFeeTotalCost: string;
  PaintProvided: string;
  AdjustmentsSetStatus: string;
  AdjustmentsSetName: string;
  PriceCustomAdjustments: string;
  CorePaint: string;
  CoreCleaning: string;
  CoreCarpetCleaning: string;
  CoreMaintenance: string;
  PaintAddons_Ceilings: string;
  PaintAddons_ColorChange: string;
  PaintAddons_DoubleCoat: string;
  PaintAddons_PrimerCoat: string;
  PaintAddons_PrimerCoatCeilings: string;
  PaintAddons_CeilingColorChange: string;
  PaintAddons: string;
  ResurfacingAddons: string;
  MaintenanceAddons: string;
  CleaningAddons: string;
  CarpetCleaningAddons: string;
  Repair: string;
  Flooring: string;
  CleanExtraUnitConditions: string;
  PaintExtrasPerUnitConditions: string;
  ClubhouseAmenityCleaning: string;
  DealMargin: string;

  constructor() {
    this.ReportName = '';
    this.User = '';
    this.Date_Time_UTC = '';
    this.CompanyName = '';
    this.MarketsQty = '';
    this.UnitsQty = '';
    this.MarketsUnitsList = '';
    this.PaintDiscount = '';
    this.CleanDiscount = '';
    this.CarpetCleanDiscount = '';
    this.MaintenanceDiscount = '';
    this.OverallDiscount = '';
    this.PlatformFeeStatus = '';
    this.PlatformFee = '';
    this.ContractedUnits = '';
    this.PlatformFeePerUnit = '';
    this.PlatformFeeTotalCost = '';
    this.PaintProvided = '';
    this.AdjustmentsSetStatus = '';
    this.AdjustmentsSetName = '';
    this.PriceCustomAdjustments = '';
    this.CorePaint = '';
    this.CoreCleaning = '';
    this.CoreCarpetCleaning = '';
    this.CoreMaintenance = '';
    this.PaintAddons_Ceilings = '';
    this.PaintAddons_ColorChange = '';
    this.PaintAddons_DoubleCoat = '';
    this.PaintAddons_PrimerCoat = '';
    this.PaintAddons_PrimerCoatCeilings = '';
    this.PaintAddons_CeilingColorChange = '';
    this.PaintAddons = '';
    this.ResurfacingAddons = '';
    this.MaintenanceAddons = '';
    this.CleaningAddons = '';
    this.CarpetCleaningAddons = '';
    this.Repair = '';
    this.Flooring = '';
    this.CleanExtraUnitConditions = '';
    this.PaintExtrasPerUnitConditions = '';
    this.ClubhouseAmenityCleaning = '';
    this.DealMargin = '';
  }

  async maybeAddTable(visual: VisualDescriptor): Promise<void> {
    const id = visual.name;

    let value = null;

    switch (id) {
      case VISUAL_IDS.CORE_TABLE:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.addCoreTable(value);
        break;
      case VISUAL_IDS.ADDONS_TABLE:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.addAddonsTable(value);
        break;
      case VISUAL_IDS.PAINT_ADDONS_REPAIR:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.PaintAddons = this.addAny(value, row25);
        this.Repair = this.addAny(value, row30);
        this.PaintExtrasPerUnitConditions = this.addAny(value, row32, row32Alias);
        break;
      case VISUAL_IDS.RESURFACING_ADDONS:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.ResurfacingAddons = this.addAny(value, row26);
        break;
      case VISUAL_IDS.MAINTENANCE_ADDONS:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.MaintenanceAddons = this.addAny(value, row27);
        break;
      case VISUAL_IDS.CLEANING_ADDONS:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.CleaningAddons = this.addAny(value, row28);
        this.CleanExtraUnitConditions = this.addAny(value, row33, row33Alias);
        break;
      case VISUAL_IDS.CARPET_CLEANING_ADDONS:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.CarpetCleaningAddons = this.addAny(value, row29);
        break;
      case VISUAL_IDS.FLOORING:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.Flooring = this.addAny(value, row31) || 'None';
        break;
      case VISUAL_IDS.DEAL_MARGIN:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.DealMargin = (value.match(/(\d+\.\d+)%/)?.[1] || 'No match found') + '%';
        break;
      case VISUAL_IDS.OVERALL_DISCOUNT:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.OverallDiscount = (value.match(/(-?\d+\.\d+)%/)?.[1] || '') + '%';
        break;
      case VISUAL_IDS.SAAS_UNIT_COUNT_CARD:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.ContractedUnits = value.trim().split('\r\n')[1].replace(/"/g, '');
        break;
      case VISUAL_IDS.SAAS_TOTAL_CARD:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.PlatformFeeTotalCost = value.trim().split('\r\n')[1].replace('$', '');
        break;
      case VISUAL_IDS.SAAS_UNIT_FEE_CARD:
        value = (await visual.exportData(models.ExportDataType.Summarized)).data;
        this.PlatformFeePerUnit = value.trim().split('\r\n')[1].replace('$', '');
        break;
      default:
        break;
    }
  }

  async maybeAddSlicer(visual: VisualDescriptor): Promise<void> {
    const id = visual.name;

    switch (id) {
      case VISUAL_IDS.PAINT_DISCOUNT:
        const discountValue = ((await visual.getSlicerState()).filters[0] as any).values[0] * 100;
        this.PaintDiscount = discountValue.toFixed(2) + '%';
        break;
      case VISUAL_IDS.CLEAN_DISCOUNT:
        const cleanDiscountValue = ((await visual.getSlicerState()).filters[0] as any).values[0] * 100;
        this.CleanDiscount = cleanDiscountValue.toFixed(2) + '%';
        break;
      case VISUAL_IDS.CARPET_CLEAN_DISCOUNT:
        const carpetCleanDiscountValue = ((await visual.getSlicerState()).filters[0] as any).values[0] * 100;
        this.CarpetCleanDiscount = carpetCleanDiscountValue.toFixed(2) + '%';
        break;
      case VISUAL_IDS.MAINTENANCE_DISCOUNT:
        const maintenanceDiscountValue = ((await visual.getSlicerState()).filters[0] as any).values[0] * 100;
        this.MaintenanceDiscount = maintenanceDiscountValue.toFixed(2) + '%';
        break;
      case VISUAL_IDS.SAAS_BILLING_CYCLE:
        const billingCycleValue = ((await visual.getSlicerState()).filters[0] as any).values[0];
        this.PlatformFee = billingCycleValue.toString();
        break;
      case VISUAL_IDS.SAAS_FEE_ENABLED.REPORT1:
        const feeEnabledValue = ((await visual.getSlicerState()).filters[0] as any).values[0];
        this.PlatformFeeStatus = feeEnabledValue;
        break;
      default:
        break;
    }
  }

  addCoreTable(value: string) {
    // Split the CSV data into lines
    const lines = value.trim().split('\r\n');

    // Split the header line to find the indices of the desired columns
    const headers = lines[0].split(',');
    const configIndex = headers.indexOf('config');
    const paintingIndex = headers.indexOf('Painting');
    const cleaningIndex = headers.indexOf('Cleaning');
    const carpetCleaningIndex = headers.indexOf('Carpet Cleaning');
    const coreMaintenanceIndex = headers.indexOf('Maintenance');

    // Initialize arrays to hold the formatted key-value pairs for each category
    const paintingData: string[] = [];
    const cleaningData: string[] = [];
    const carpetCleaningData: string[] = [];
    const coreMaintenanceData: string[] = [];

    // Process each subsequent line to extract the config and values for each category
    lines.slice(1).forEach(line => {
      const columns = line.split(',');
      const config = columns[configIndex].trim();
      const paintingValue = columns[paintingIndex].trim().replace('$', '');
      const cleaningValue = columns[cleaningIndex].trim().replace('$', '');
      const carpetCleaningValue = columns[carpetCleaningIndex].trim().replace('$', '');
      const coreMaintenanceValue = columns[coreMaintenanceIndex].trim().replace('$', '');

      paintingData.push(`{${config}:${paintingValue}}`);
      cleaningData.push(`{${config}:${cleaningValue}}`);
      carpetCleaningData.push(`{${config}:${carpetCleaningValue}}`);
      coreMaintenanceData.push(`{${config}:${coreMaintenanceValue}}`);
    });

    // Join the formatted data with commas for each category
    const paintingResult = paintingData.join(',');
    const cleaningResult = cleaningData.join(',');
    const carpetCleaningResult = carpetCleaningData.join(',');
    const coreMaintenanceResult = coreMaintenanceData.join(',');

    this.CorePaint = paintingResult;
    this.CoreCleaning = cleaningResult;
    this.CoreCarpetCleaning = carpetCleaningResult;
    this.CoreMaintenance = coreMaintenanceResult;
  }

  addAddonsTable(value: string) {
    // Split the CSV data into lines
    const lines = value.trim().split('\r\n');

    // Split the header line to find the indices of the desired columns
    const headers = lines[0].split(',');
    const configIndex = headers.indexOf('config');
    const ceilingsIndex = headers.indexOf('Ceilings');
    const colorChangeIndex = headers.indexOf('Color Change');
    const doubleCoatIndex = headers.indexOf('Double Coat');
    const primerCoatIndex = headers.indexOf('Primer Coat');
    const primerCoatCeilingsIndex = headers.indexOf('Primer Coat Ceilings');
    const ceilingColorChangeIndex = headers.indexOf('Ceiling Color Change');

    // Initialize arrays to hold the formatted key-value pairs for each category
    const ceilingsData: string[] = [];
    const colorChangeData: string[] = [];
    const doubleCoatData: string[] = [];
    const primerCoatData: string[] = [];
    const primerCoatCeilingsData: string[] = [];
    const ceilingColorChangeData: string[] = [];

    // Process each subsequent line to extract the config and values for each category
    lines.slice(1).forEach(line => {
      const columns = line.split(',');
      const config = columns[configIndex].trim();
      const ceilingsValue = columns[ceilingsIndex].trim().replace('$', '');
      const colorChangeValue = columns[colorChangeIndex].trim().replace('$', '');
      const doubleCoatValue = columns[doubleCoatIndex].trim().replace('$', '');
      const primerCoatValue = columns[primerCoatIndex].trim().replace('$', '');
      const primerCoatCeilingsValue = columns[primerCoatCeilingsIndex].trim().replace('$', '');
      const ceilingColorChangeValue = columns[ceilingColorChangeIndex].trim().replace('$', '');

      ceilingsData.push(`{${config}:${ceilingsValue}}`);
      colorChangeData.push(`{${config}:${colorChangeValue}}`);
      doubleCoatData.push(`{${config}:${doubleCoatValue}}`);
      primerCoatData.push(`{${config}:${primerCoatValue}}`);
      primerCoatCeilingsData.push(`{${config}:${primerCoatCeilingsValue}}`);
      ceilingColorChangeData.push(`{${config}:${ceilingColorChangeValue}}`);
    });

    // Join the formatted data with commas for each category
    const ceilingsResult = ceilingsData.join(',');
    const colorChangeResult = colorChangeData.join(',');
    const doubleCoatResult = doubleCoatData.join(',');
    const primerCoatResult = primerCoatData.join(',');
    const primerCoatCeilingsResult = primerCoatCeilingsData.join(',');
    const ceilingColorChangeResult = ceilingColorChangeData.join(',');

    this.PaintAddons_Ceilings = ceilingsResult;
    this.PaintAddons_ColorChange = colorChangeResult;
    this.PaintAddons_DoubleCoat = doubleCoatResult;
    this.PaintAddons_PrimerCoat = primerCoatResult;
    this.PaintAddons_PrimerCoatCeilings = primerCoatCeilingsResult;
    this.PaintAddons_CeilingColorChange = ceilingColorChangeResult;
  }

  addAny(value: string, names?: string[], allias?: string[]) {
    // Split the CSV data into lines
    const lines = value.trim().split('\r\n');

    // Initialize an array to hold the formatted key-value pairs
    const formattedData: string[] = [];

    // Process each subsequent line to extract the addon name and price
    lines.slice(1).forEach(line => {
      const columns = line.split(',');
      const addonName = columns[0].trim();

      if (names) {
        const index = names?.indexOf(addonName);
        if (index === -1) {
          return;
        }

        const priceValue = columns[1].trim().replace('$', '');
        const formattedLine = `{${allias ? allias[index] : addonName}:${priceValue}}`;
        formattedData.push(formattedLine);
      } else {
        const priceValue = columns[1].trim().replace('$', '');
        const formattedLine = `{${addonName}:${priceValue}}`;
        formattedData.push(formattedLine);
      }
    });

    // Join the formatted data with commas
    const result = formattedData.join(',');

    return result;
  }

  export(exportName: string) {
    if (this.PlatformFeeStatus === 'No') {
      this.PlatformFee = '';
      this.ContractedUnits = '';
      this.PlatformFeePerUnit = '';
      this.PlatformFeeTotalCost = '';
    }

    // Array to hold all result arrays
    const allResults = [];

    allResults.push(['Order', 'Group', 'Parameter', 'Value']);

    let i = 0;
    for (const [key, value] of Object.entries(this)) {
      allResults.push([i, i < 3 ? 'Properties' : i < 21 ? 'Inputs' : i < 41 ? 'Prices' : 'Margin', key, value]);

      ++i;
    }

    // Create a new workbook and a new worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(allResults);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write the workbook to a file
    const filePath = `${exportName}.xlsx`;
    XLSX.writeFile(workbook, filePath);
  }
}

const row25 = [
  'Accent Wall',
  'Accent Wall Coverup',
  'Bathroom Cabinet Boxes',
  'Bathroom Cabinet Fronts',
  'Bathroom Cabinets - Full',
  'Bathroom Cabinets Primer',
  'Extra Wall Prep',
  'Full Bathroom Cabinets',
  'Full Kitchen Cabinets',
  'Garage Painting Double',
  'Garage Painting Single',
  'Kitchen Cabinet Boxes',
  'Kitchen Cabinet Fronts',
  'Kitchen Cabinets - Full',
  'Kitchen Cabinets Primer',
  'New Fireplace Paint',
  'Paint Exterior Door',
  'Paint Stairs',
  'Trim Color Change',
  'Wallpaper Removal',
];

const row26 = [
  'Bar/Extra Countertop Area',
  'Bathroom Counter Resurfacing',
  'Bottom Crack And Foam',
  'Chemical Tub Stripping',
  'Counter Repair',
  'Kitchen Counter Resurfacing',
  'Resurface Backsplash',
  'Shower Basin',
  'Side Crack/Basic Crack',
  'Sink Resurfacing',
  'Surround Refinishing',
  'Tub And Surround Stripping',
  'Tub Refinishing',
  'Tub Stripping',
];

const row27 = [
  'All Other Appliances',
  'Bathroom Cabinet Front Installation',
  'Blind Installation',
  'Ceiling Fan Installation',
  'Dishwasher Installation',
  'Disposal Installation',
  'Door Hardware Package',
  'Door Slab Installation',
  'Faucet Installation',
  'Fridge Installation',
  'Heavy Trashout',
  'Kitchen Cabinet Front Installation',
  'Light Fixture Installation',
  'Microwave Install',
  'Outlet & Switch Plate Cover Package',
  'Sink Installation',
  'Stove Installation',
  'Trashout',
  'Trim Repair',
  'Venthood Installation',
];

const row28 = ['Extra Dirty Clean', 'Paid Touch-Up', 'Removal of 3 to 5 bags of trash'];

const row29 = [
  'After Hours Carpet',
  'Carpet Blower',
  'Carpet Mildew Treatment',
  'Dehumidifier 19/G',
  'Dehumidifier 29/G',
  'Large Patch',
  'Large Stain',
  'Large Tack Strip',
  'Medium Patch',
  'Medium Stain',
  'Odor Removal',
  'Ozone Machine',
  'Pet Treatment',
  'Power Scrub',
  'Small Patch',
  'Small Stain',
  'Small Tack Strip',
  'Staircase',
  'Stretching',
  'Transition Strip',
  'Water Extraction',
];

const row30 = [
  'Extra Large Sheetrock Repair',
  'Extra Large Texture Repair',
  'Seam Repair',
  'Standard Sheetrock Repair',
  'Standard Texture Repair',
];

const row31 = [
  '20oz Carpet',
  '25oz Carpet',
  'Carpet Stair',
  'Floating/Interlocking 12mil LVP',
  'Glue Down 6mil LVP',
  'Plywood Subfloor Repair',
  'Sheet Vinyl 55GA',
  'Sheet Vinyl 65GA',
];

const row32Alias = ['Extra Room', 'Extra Trim', 'Roll Only', 'Townhome', 'Vaulted Ceilings'];

const row32 = [
  'Extra Room - Painting',
  'Extra Trim - Painting',
  'Roll Only Propery - Painting',
  'Townhome - Painting',
  'Vaulted Ceilings - Painting',
];

const row33Alias = ['Extra Room', 'Townhome'];

const row33 = ['Extra Room - Cleaning', 'Townhome - Cleaning'];

export default ExcelModel;
